// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
import VueMeta from 'vue-meta';

// Import only the Bootstrap Vue components that are actually used
import {
  // Layout
  BContainer,
  BCol,
  BFormRow,
  // Navigation
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNav,
  BNavItem,
  BCollapse,
  // Buttons
  BButton,
  BButtonGroup,
  // Cards
  BCard,
  // Forms
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BFormRadioGroup,
  // Display
  BSpinner,
  BAlert,
  BBadge,
  BAvatar,
  BProgress,
  BLink,
  // Carousel
  BCarousel,
  BCarouselSlide,
  // Modal
  BModal,
  // Directives
  VBToggle,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import Loader from '@/components/widgets/Loader';
import VueMasonry from 'vue-masonry-css';
import 'vue-select/dist/vue-select.css';
import LoadScript from 'vue-plugin-load-script';
import VueAnalytics from 'vue-analytics';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Only import critical icons that are needed immediately
import { faHeart, faBars, faSignOutAlt, faUser, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

Vue.component('v-select', vSelect);

library.add(faHeart, faBars, faSignOutAlt, faUser, faShoppingCart);
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
Vue.config.productionTip = false;

// Register only the Bootstrap Vue components we actually use
Vue.component('BContainer', BContainer);
Vue.component('BCol', BCol);
Vue.component('BFormRow', BFormRow);
Vue.component('BNavbar', BNavbar);
Vue.component('BNavbarBrand', BNavbarBrand);
Vue.component('BNavbarToggle', BNavbarToggle);
Vue.component('BNavbarNav', BNavbarNav);
Vue.component('BNav', BNav);
Vue.component('BNavItem', BNavItem);
Vue.component('BCollapse', BCollapse);
Vue.component('BButton', BButton);
Vue.component('BButtonGroup', BButtonGroup);
Vue.component('BCard', BCard);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormRadioGroup', BFormRadioGroup);
Vue.component('BSpinner', BSpinner);
Vue.component('BAlert', BAlert);
Vue.component('BBadge', BBadge);
Vue.component('BAvatar', BAvatar);
Vue.component('BProgress', BProgress);
Vue.component('BLink', BLink);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
Vue.component('BModal', BModal);

// Register the v-b-toggle directive
Vue.directive('b-toggle', VBToggle);
Vue.use(Loader);
Vue.use(VueMasonry);
Vue.use(LoadScript);
Vue.use(VueMeta);

Vue.use(VueAnalytics, {
  id: 'UA-221726265-1',
  router,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js